import React from 'react';
import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 40px;
  flex: 1;
  .colors-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    span {
      margin-bottom: 5px;
      margin-left: 10px;
    }
  }

  @media (max-width: 1200px) {
    .colors-container {
    }
  }
`;

function ColorSkeleton() {
  return (
    <Wrapper>
      <Title>Color</Title>
      <div className="colors-container">
        <Skeleton count={12} circle={true} height={20} width={20} />
      </div>
    </Wrapper>
  );
}

export default ColorSkeleton;

const Title = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: ${({ theme }) => theme.old ? 'bold' : 600};
  font-size: 13px;
  line-height: 23px;
  letter-spacing: 0.12em;
  text-transform: uppercase;

  color: ${({ theme }) => theme.colors.charcoal};
`;

const Multi = styled.div`
  margin-bottom: 5px;
  cursor: pointer;
  border-radius: 50%;
  display: inline-grid;
  margin-left: 10px;
  border-radius: 50%;
  border: ${({ selected }) =>
    selected ? '2px solid #A83569' : '1px solid white'};

  img {
    border-radius: 50%;
    border: ${({ selected }) => (selected ? '1px solid white' : 'none')};
    height: 20px;
    width: auto;
  }
`;

export const ColorDot = styled.span`
  margin-bottom: 5px;
  cursor: pointer;
  display: inline-block;
  margin-left: 5px;
  border-radius: 50%;
  background: ${({ color }) => color};
  border: ${({ color, selected }) =>
    selected
      ? '2px solid #fff'
      : color === 'white' || color === '#FFFFFF'
      ? '1px solid #C9C9C9'
      : '1px solid #fff'};
  height: 20px;
  width: 20px;
  max-width: 20px;

  box-shadow: ${({ color, selected }) =>
    selected ? '0 0 0 2px #a83569;' : 'none'};
`;
